import { getDetailLabel } from '@/shared/copy/details';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { TestRunStatus } from '@flowqa/shared';

export type TestRunSortDirection = 'asc' | 'desc';
export type TestRunSortKey =
  | 'testName'
  | 'suiteName'
  | 'status'
  | 'durationMs'
  | 'timestamp'
  | 'runNumber'
  | 'runId';

export const testRunDefaultSortKey: TestRunSortKey = 'timestamp';
export const testRunDefaultSortDirection: TestRunSortDirection = 'desc';

export const testRunSortOptions: Array<{
  key: TestRunSortKey;
  label: string;
}> = [
  { key: 'testName', label: 'Test' },
  { key: 'suiteName', label: 'Suite' },
  { key: 'status', label: getDetailLabel('status') },
  { key: 'durationMs', label: getDetailLabel('duration') },
  { key: 'timestamp', label: 'Executed' },
  { key: 'runNumber', label: getDetailLabel('run') },
  { key: 'runId', label: getDetailLabel('details') },
];

export const testRunSortFieldMap: Record<TestRunSortKey, string> = {
  testName: 'testName',
  suiteName: 'suiteName',
  status: 'status',
  durationMs: 'durationMs',
  timestamp: 'timestamp',
  runNumber: 'runNumber',
  runId: 'runId',
};

export const testRunColumnOptions: Array<{
  field: string;
  label: string;
  mandatory?: boolean;
}> = [
  { field: 'name', label: 'Test', mandatory: true },
  { field: 'status', label: getDetailLabel('status') },
  { field: 'runNumber', label: getDetailLabel('run') },
  { field: 'output', label: getDetailLabel('output') },
  { field: 'details', label: getDetailLabel('details') },
];

export const testRunStatusOptions: Array<{
  value: TestRunStatus;
  label: string;
}> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'skipped', label: 'Skipped' },
  { value: 'errored', label: 'Errored' },
];

export const testRunDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  status: true,
  runNumber: true,
  output: true,
  details: true,
};
